import { useState } from 'react';

import { useHistory } from 'react-router';
import { HOTELS } from '@shared/helpers/routes';

import Steps from '@shared/components/Steps/steps';
import { ConfirmDialogModal } from '@shared/components/Dialogs';

const StepsWrapper = ({ isaBuying = true }) => {
  const [showModal, setShowModal] = useState(false);
  const [showModalPersonal, setShowModalPersonal] = useState(false);
  const history = useHistory();

  return (
    <>
      <Steps
        setShowModal={setShowModal}
        activeStep={3}
        stepsConfig={{
          box1: {
            subtitle: 'Seleccioná tu alojamiento',
            subtitleMobile: 'Alojamiento seleccionado',
          },

          box2: {
            subtitle: `Ingresá tus datos personales`,
            subtitleMobile: `Datos personales`,
          },

          box3: isaBuying
            ? {
                subtitle: 'Pagá y confirmá tu reserva',
                subtitleMobile: 'Pagar y confirmar',
              }
            : null,
        }}
      />

      <ConfirmDialogModal
        isOpen={showModal}
        onConfirm={() => {
          history.push(HOTELS);
          setShowModal(false);
        }}
        onCancel={() => {
          setShowModal(false);
        }}
        text="¿Estás seguro de salir del último paso? Se borrarán los datos cargados."
      />

      <ConfirmDialogModal
        isOpen={showModalPersonal}
        onConfirm={() => {
          history.goBack();
          setShowModalPersonal(false);
        }}
        onCancel={() => {
          setShowModalPersonal(false);
        }}
        text="¿Estás seguro de salir del último paso? Se borrarán los datos cargados."
      />
    </>
  );
};

export default StepsWrapper;
